import { styled } from "@mui/material";

export const LobbyBody = styled("div")({ textAlign: "left", fontSize: "14pt" });
